export default __webpack_public_path__ + "static/media/rightArrow.aedfff6c.svg";